import styled from 'styled-components';

export const HintWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;

  /* Keep the command and Copy on one line next to the label when there is room. */
  @media (min-width: 992px) {
    flex-wrap: nowrap;
  }

  .hint-label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
  }

  code {
    font-family: 'SF Mono', SFMono-Regular, Consolas, 'Liberation Mono', Menlo,
      Courier, monospace;
    font-size: 13px;
    color: #fff;
    background: rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 5px;
    padding: 5px 10px;
    white-space: nowrap;
  }

  button {
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    padding: 4px 10px;
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }
  }
`;
